import {Deserializable} from "./deserializable.model";

export class JobSubjectServiceType {

    subject_service_type_id: number;
    subject_service_type_name: string;
    subject_service_type_description: string;
    is_active: string;
    job_service_rule_id_change_to: number;



  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): JobSubjectServiceType {
    Object.assign(this, input);

    return this;
  }


}
